import {apiFetch} from '../_helpers';


export const loyaltyMovementsService = {
    getAll,
};


function getAll() {
    return apiFetch("loyaltymovements/");
}